import { addDoc, collection } from "firebase/firestore";
import { db } from "@/firebase";
import { Collections } from "@/constants/firebase.collections";
import { Email } from "@/models/email";

export const saveEmail = async (emailData: Email): Promise<void> => {
  try {
    await addDoc(collection(db, Collections.EMAILS), emailData);
  } catch (error) {
    console.error("Error saving email:", error);
    throw error;
  }
};
